module.exports = new __parcel__URL__("0t.608f359d.png").toString();